import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error" }

import { computed, toRef } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ValidationError',
  props: {
    context: {},
    errors: {}
  },
  setup(__props: any) {

    const props = __props

    const context = toRef(props, 'context')
    const errors = toRef(props, 'errors')

    const error = computed(() =>
        errors.value?.find(e => e.Context === context.value) ?? null
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(error.value ? error.value.Error : ''), 1 /* TEXT */))
}
}

})